import React from "react";
import useAuth from '~/view-data/use-auth';
import _ from "lodash";
import EmptyState from "~/components/empyt-state";

import { Timeline } from "~/views/partners/contract/styles";
import { formats } from "~/helper";

const contractTypeMap = {
  contract: "Contrato",
  addition: "Contrato de Aditamento",
  additive: "Aditivo",
  cancellation: "Distrato",
  ip_address_update: "Atualização de IPs/DDNS"
};

function TabHistory({
  disabled,
  values = {},
  errors,
  touched,
  onSignContract = _.noop,
  onDownloadContract = _.noop
}) {
  const { state: authState } = useAuth();
  // Busca permissão de listagem de IP/DDNS (A13)
  const canListIpHistory = React.useMemo(() => {
    const menu = authState && authState.menu;
    if (!menu) return false;
    function findA13(arr) {
      for (const item of arr) {
        if (item.code === 'A13') return item;
        if (item.children && Array.isArray(item.children)) {
          const found = findA13(item.children);
          if (found) return found;
        }
      }
      return null;
    }
    const ipMenu = Array.isArray(menu) ? findA13(menu) : null;
    if (!ipMenu || !ipMenu.perms) return false;
    // Permite visualizar histórico se tiver permissão de leitura OU escrita
    return ipMenu.perms.includes('R') || ipMenu.perms.includes('W');
  }, [authState]);
  console.log('History Entries:', values.historyEntries); // Log the history entries to inspect the data

  let historyEntries = [...(values.historyEntries || [])].sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
  // Oculta histórico de IP se não tiver permissão
  if (!canListIpHistory) {
    historyEntries = historyEntries.filter(entry => entry.contractType !== 'ip_address_update');
  }

  if (_.isEmpty(historyEntries)) {
    return (
      <EmptyState
        text={"Contrato sem histórico"}
        visible={true}
        size={"200px"}
      />
    );
  }

  return (
    <Timeline>
      {historyEntries.map((entry, index) => (
        <li
          key={index}
          data-date={formats.dateTimeZone(entry.createdAt, "dd/MM/yyyy HH:mm")}
        >
          <div>
            <h3>{contractTypeMap[entry.contractType]}</h3>
            {(entry.services || []).map((service, serviceIndex) => (
              <p key={serviceIndex}>
                {service.description && (
                  <span><strong>Alteração:</strong> {service.description}<br /></span>
                )}
                <strong>{formats.cnpj_cpf(service.identify)}</strong>
                {(service.modules && service.modules.length > 0) && (
                  <>: {service.modules.map((module, moduleIndex) => (
                    <span key={moduleIndex}>
                      Módulo: {module.moduleName} - {
                        module.licenseMode === 'temporary' ? 'Temporária' :
                        module.licenseMode === 'indeterminate' ? 'Indeterminada' :
                        module.licenseMode === 'blocked' ? 'Bloqueada' : module.licenseMode
                      }
                      {moduleIndex < service.modules.length - 1 ? '; ' : ''}
                    </span>
                  ))}</>
                )}
              </p>
            ))}
          </div>
        </li>
      ))}
    </Timeline>
  );
}

export default TabHistory;
